import { createFileRoute } from "@tanstack/react-router";
import { OrdersLayout } from "../features/order/panes";

/** The Orders tab: the live board, an order (beside the board on wide screens), or the KOT list. */
export const Route = createFileRoute("/orders")({ component: OrdersLayout });
